<script setup lang="ts">

import MenuIcon from '@/components/icons/MenuIcon.vue'
import SettingsIcon from '@/components/icons/SettingsIcon.vue'
import { useTranslate } from '@tolgee/vue'
import { RouteName } from '@/routes'
import { useRoutePath } from '@/composables/helpers/route-path'
import router from '@/router'
import { ref } from 'vue'
import LightBulbIcon from '@/components/icons/LightBulbIcon.vue'
import TelegramIcon from '@/components/icons/TelegramIcon.vue'

const { t } = useTranslate()
const { getPathByName } = useRoutePath()
const isOpen = ref(false)

type MenuItem = { icon: unknown, name: string, route?: string, externalUrl?: string }

const menuItems: MenuItem[] = [
  {
    icon: SettingsIcon,
    name: t.value('general.settings', 'Settings'),
    route: getPathByName(RouteName.SETTINGS),
  },
  {
    icon: LightBulbIcon,
    name: t.value('general.tutorials', 'Tutorials'),
    route: getPathByName(RouteName.TUTORIALS),
  },
  {
    icon: TelegramIcon,
    name: t.value('general.join_channel', 'Join channel'),
    externalUrl: 'https://t.me/dropee_community',
  },
]

function onClose() {
  setTimeout(() => isOpen.value = false, 50)
}

function onClick(menuItem: MenuItem) {
  isOpen.value = false
  if (!menuItem.route) return
  router.push(menuItem.route)
}
</script>

<template>
  <div class="z-[30]">
    <VDropdown
      placement="bottom"
      :shown="isOpen"
      :flip="false"
      :distance="12"
      :skidding="-76"
      popper-class="max-w-[180px] w-[180px]"
      @apply-hide="onClose"
      @apply-show="isOpen = true"
    >
      <MenuIcon
        class="size-7 min-w-[28px] text-white"
      />
      <template #popper>
        <div class="w-full flex flex-col px-2">
          <component
            v-for="(menuItem, index) in menuItems"
            :key="index"
            :is="!!menuItem.route ? 'div' : 'a'"
            :href="menuItem.externalUrl"
            target="_blank"
            class="flex items-center gap-x-3 p-4 border-b border-b-white/[.12] last:border-b-transparent"
            @click="onClick(menuItem)"
          >
            <component :is="menuItem.icon" />
            <div class="text-base font-medium -tracking-[0.32px]">
              {{ menuItem.name }}
            </div>
          </component>
        </div>
      </template>
    </VDropdown>
  </div>
  <div
    v-if="isOpen"
    class="fixed h-screen w-screen inset-0 z-[29] bg-black/20 backdrop-blur-sm"
    aria-hidden="true"
  />
</template>

<style scoped>

</style>